module.exports = __webpack_public_path__ + "img/bg_vocabulary_01.fffdaad3.jpg";